var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"app-header flex-x-center flex-space-between"},[_c('img',{staticClass:"app-header-bi",attrs:{"src":require("@/assets/img/bi_order_app_v.png")}}),_c('div',{staticClass:"icoHome",on:{"click":function($event){return _vm.appMoveMain()}}})]),_c('BottomMenu')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }